import React from "react";
import promotionImage from "../../assets/svg-asset-2.png";
import "./Promotion.css";

const Promotion = () => (
  <div className="promotion section__padding" id="promotion">
    <div className="promotion-image">
      <img src={promotionImage} alt="promotion" />
    </div>
    <div className="promotion-content">
      <h4>Web Development</h4>
      <h1 className="gradient__text">
        Immaculately designed websites
        <br /> built for the new wave of the internet.
      </h1>
      <p>
        We design our websites to be performant, eye catching and{" "}
        <span className="">pixel perfect </span>
        on all screens. We ensure our websites are interactive and the user
        experience is never compromised.
      </p>
      <h4>See more..</h4>
    </div>
  </div>
);

export default Promotion;
